import AppConst from '../../constants/app.constant';

export const getKeyValueFromLocalStorage = (key) => {
  if (key) {
    return localStorage.getItem(AppConst.localstorageConf.prefix + key);
  }
  return null;
};
